$(function () {
  /** ============================
   *  フィルター処理
   * ============================ */
  const posts = document.querySelectorAll(".p-Posts__col");
  const filterRadios = document.querySelectorAll('input[name="filter"]');
  const filterButtons = document.querySelectorAll(".p-Filter__btn input");
  const titleElement = document.querySelector(".p-FilterTitle__text span b");

  const availableFilters = new Set();

  // 投稿に使われているフィルターを収集
  if (posts.length) {
    posts.forEach((post) => {
      const filters = post.dataset.filter_item ? post.dataset.filter_item.split(",") : [];
      filters.forEach((filter) => availableFilters.add(filter.trim()));
    });

    // 使われていないフィルターを削除
    filterButtons.forEach((btn) => {
      if (btn.value !== "all" && !availableFilters.has(btn.value)) {
        btn.closest("li")?.remove();
      }
    });
  }
  // URL パラメータ取得 & フィルター適用
  const urlParams = new URLSearchParams(window.location.search);
  const currentFilter = urlParams.get("filter") || "all";

  filterRadios.forEach((radio) => {
    radio.checked = radio.value === currentFilter;
  });

  function applyFilter(selectedFilter) {
    posts.forEach((post) => {
      const postFilters = post.dataset.filter_item ? post.dataset.filter_item.split(",") : [];
      const shouldShow = selectedFilter === "all" || postFilters.includes(selectedFilter);
      post.style.display = shouldShow ? "block" : "none";
      post.style.opacity = shouldShow ? "1" : "0";
    });

    // 選択したフィルタのラベルを取得
    const selectedLabel = document.querySelector(`input[name="filter"][value="${selectedFilter}"]`)?.parentNode.textContent.trim();

    // タイトルを選択フィルタのラベルに更新
    if (selectedLabel) {
      titleElement.textContent = selectedLabel;
    }

    // URL の更新
    const newUrl = new URL(window.location);
    selectedFilter === "all" ? newUrl.searchParams.delete("filter") : newUrl.searchParams.set("filter", selectedFilter);
    history.pushState(null, "", newUrl);

    // 条件付きで高さ調整
    setTimeout(() => {
      if ($(".c-FxItem:visible").length > 0) {
        $(window).trigger("resize");
      }
    }, 0);
  }

  applyFilter(currentFilter);

  filterRadios.forEach((radio) => {
    radio.addEventListener("change", function () {
      applyFilter(this.value);
    });
  });

  /** ============================
   *  モバイル用フィルター制御
   * ============================ */

  // モバイル用フィルター制御（991px以下のみ）
  if (window.matchMedia("(max-width: 991px)").matches) {
    const filterButton = document.querySelector(".p-FilterTitle__filter");
    const filter = document.querySelector(".p-Filter");
    const filterInner = document.querySelector(".p-Filter__bg");
    const filterClose = document.querySelector(".p-Filter__close");
    const radioButtons = document.querySelectorAll(".p-Filter__btn input[type='radio']");
    let scrollPosition = 0;

    function disableScroll() {
      scrollPosition = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = "100%";
    }

    function enableScroll() {
      document.body.style.position = "";
      document.body.style.top = "";
      window.scrollTo(0, scrollPosition);
    }

    filterButton?.addEventListener("click", () => {
      filter.style.display = "block";
      disableScroll();
    });

    filterInner?.addEventListener("click", () => {
      filter.style.display = "none";
      enableScroll();
    });

    filterClose?.addEventListener("click", () => {
      filter.style.display = "none";
      enableScroll();
    });

    radioButtons.forEach((radio) =>
      radio.addEventListener("change", () => {
        filter.style.display = "none";
        enableScroll();
      })
    );
  }
});
